<template>
<div class="control-panel" style="position:relative;height:100%;margin:0px;display:flex;flex-direction:column">

  <div class="left-border" @mousedown="$emit('drag:left')"></div>
  <div class="bottom-right-border" @mousedown="$emit('drag:bottom-right', $event.clientX, $event.clientY)"></div>

  <!-- TOP -->
  <div class="control-panel-top" style="flex-grow:1">
    <div class="object-row" v-for="(object, i) in store.objects" :id="`object-row-${object.id}`" :key="10000000+i">
      <div @click="(object.visible ? object.hide() : object.show());$emit('toggle:selection')" :style="{width:`${objectNameWidth}px`}" :class="{'object-name':true, 'object-name-active':object.visible}">
          <div>{{ object.type === 'selection' ? `(${object.name})` : object.name }}</div>
      </div>
      <div class="object-action" @click="actionObject=object.id">
        A
      </div>
      <div class="object-show" @click="showObject=object.id">
        S
      </div>
      <div class="object-hide" @click="hideObject=object.id">
        H
      </div>
      <div class="object-label" @click="labelObject=object.id">
        L
      </div>
      <div class="object-color" @click="colorObject=object.id">
        C
      </div>
      <div class="object-setting" @click="settingObject=object.id">
        <i class="el-icon-more"></i>
      </div>
    </div>
  </div>

  <!-- BOTTOM -->
  <div class="control-panel-bottom" style="height:19px">
    <div><i class="el-icon-d-arrow-left"></i></div>
    <div><i class="el-icon-arrow-left"></i></div>
    <div><i class="el-icon-video-pause"></i></div>
    <div><i class="el-icon-video-play"></i></div>
    <div><i class="el-icon-arrow-right"></i></div>
    <div><i class="el-icon-d-arrow-right"></i></div>
    <div @click="$emit('toggle:sequence')">S</div>
    <div><i class="el-icon-arrow-down"></i></div>
    <div @click="$emit('toggle:fullscreen')"><i class="el-icon-full-screen"></i></div>
  </div>

  <div class="popup-menu" :style="getMenuStyle(actionObject)">
    <div class="menu-head">
      <div class="menu-title">ACTION</div>
      <div class="menu-close" @click="actionObject=-1"><i class="el-icon-close"></i></div>
    </div>
    <div class="menu-body">
      <div class="menu-row" @click="store.getObjectById(actionObject).zoom();actionObject=-1">zoom</div>
      <div class="menu-row rename-box" @click="renameVisible=!renameVisible">
        rename
        <div v-show="renameVisible" @click.stop="" class="rename-input"><input @keyup.enter="store.getObjectById(actionObject).name=$event.target.value;actionObject=-1"></div>
      </div>
      <div class="menu-row" @click="$emit('object:delete', actionObject);actionObject=-1">delete</div>
    </div>
  </div>

  <div class="popup-menu" :style="getMenuStyle(showObject)">
    <div class="menu-head">
      <div class="menu-title">SHOW <span @click="showAs=!showAs" style="cursor:pointer"><del v-if="!showAs">AS</del><template v-if="showAs">AS</template></span></div>
      <div class="menu-close" @click="showObject=-1"><i class="el-icon-close"></i></div>
    </div>
    <div class="menu-body">
      <div class="menu-row" @click="store.getObjectById(showObject).showRepresentation(t, showAs);showObject=-1" v-for="(t,it) in store.representationTypes" :key="10+it">
        {{ t }}
      </div>
    </div>
  </div>

  <div class="popup-menu" :style="getMenuStyle(hideObject)">
    <div class="menu-head">
      <div class="menu-title">HIDE</div>
      <div class="menu-close" @click="hideObject=-1"><i class="el-icon-close"></i></div>
    </div>
    <div class="menu-body">
      <div class="menu-row" @click="store.getObjectById(hideObject).hideRepresentation(t);hideObject=-1" v-for="(t,it) in ['everything'].concat(store.representationTypes)" :key="100+it">
        {{ t }}
      </div>
    </div>
  </div>

  <div class="popup-menu" :style="getMenuStyle(labelObject)">
    <div class="menu-head">
      <div class="menu-title">LABEL</div>
      <div class="menu-close" @click="labelObject=-1"><i class="el-icon-close"></i></div>
    </div>
    <div class="menu-body">
      <div class="menu-row" v-for="(type, i) in ['clear'].concat(store.labelTypes)" @click="store.getObjectById(labelObject).showLabel(type);labelObject=-1" :key="1000+i">{{type}}</div>
    </div>
  </div>

  <div class="popup-menu" :style="getMenuStyle(colorObject)">
    <div class="menu-head">
      <div class="menu-title">COLOR</div>
      <div class="menu-close" @click="colorObject=-1"><i class="el-icon-close"></i></div>
    </div>
    <div class="menu-body">
      <div class="menu-row" v-for="(scheme,ischeme) in ['residueindex', 'chainindex', 'element', 'bfactor', 'sstruc']" @click="store.getObjectById(colorObject).setColor(scheme);colorObject=-1" :key="10000+ischeme">
        by {{ scheme }}
      </div>
      <div class="menu-row" v-for="(color,icolor) in ['red', 'green', 'blue', 'black', 'white']" @click="store.getObjectById(colorObject).setColor(color);colorObject=-1" :key="100000+icolor">
        {{ color }}
      </div>
    </div>
  </div>

  <div class="popup-menu" :style="getMenuStyle(settingObject)">
    <div class="menu-head">
      <div class="menu-title">SETTING</div>
      <div class="menu-close" @click="settingObject=-1"><i class="el-icon-close"></i></div>
    </div>
    <div class="menu-body">
      <div class="menu-row" v-for="(type,itype) in store.representationTypes" @click="representationSetting={object:settingObject,type};settingObject=-1" :key="1000000+itype">
        {{ type }}
      </div>
    </div>
  </div>

  <div class="popup-menu repr-setting" :style="getMenuStyle(representationSetting.object)">
    <div class="menu-head">
      <div class="menu-title">{{representationSetting.type.toUpperCase()}}</div>
      <div class="menu-close" @click="representationSetting={object:-1,type:''}"><i class="el-icon-close"></i></div>
    </div>
    <div class="menu-body">
      <div class="setting-row">
        <div class="setting-label">
          aspect ratio
        </div>
        <div class="setting-number">
          {{aspectRatio}}
        </div>
        <div>
          <input v-model="aspectRatio" type="range" min="1.0" max="10.0" step="0.1">
        </div>
      </div>

      <div class="setting-row">
        <div class="setting-label">
          smooth sheet
        </div>
        <div class="setting-number">
          <input type="checkbox" v-model="smoothSheet">
        </div>
      </div>

      <div class="setting-row">
        <div class="setting-label">
          opacity
        </div>
        <div class="setting-number">
          {{opacity}}
        </div>
        <div>
          <input v-model="opacity" type="range" min="0" max="1" step="0.01">
        </div>
      </div>

      <div class="setting-row">
        <div class="setting-label">
          color
        </div>
        <div>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import * as NGL from 'ngl'
import { getRepr, hasRepr } from './NglUtils.js'

export default {
  name: 'NglControl',

  data () {
    let v = this
    return {
      style: {
        height: (v.height ? v.height : 400),
        cmdHeight: 19,
        viewportHeight: (v.height ? v.height - 20 : 380),
        viewportWidth: 400
      },

      clickedResidue: '',
      actionObject: -1,
      showObject: -1,
      hideObject: -1,
      labelObject: -1,
      colorObject: -1,
      settingObject: -1,
      representationSetting: {
        object: -1,
        type: ''
      },
      renameVisible: false,
      showAs: false,

      opacity: 1.0,
      aspectRatio: 1.0,
      smoothSheet: false
    }
  },

  computed: {
  },

  props: [ 'store', 'objectNameWidth' ],

  watch: {
    actionObject (n, o) {
      if (n === -1) {
        this.renameVisible = false
      }
    },

    showObject (n, o) {
      if (n === -1) {
        this.showAs = false
      }
    },

    representationSetting (n, o) {
      let v = this
      if (n.object !== -1) {
        let obj = v.store.getObjectById(n.object)
        if (obj.type === 'all' || obj.type === 'structure-component') {
          obj.components.forEach(comp => {
            if (hasRepr(comp, n.type)) {
              let repr = getRepr(comp, n.type)
              this.opacity = repr.getParameters().opacity
              this.aspectRatio = repr.getParameters().aspectRatio
              this.smoothSheet = repr.getParameters().smoothSheet
            } else {
              this.opacity = 1
              this.aspectRatio = 1
              this.smoothSheet = false
            }
          })
        }
      }
    },

    opacity (n, o) {
      this.setParameters(this.representationSetting.object, this.representationSetting.type, 'opacity', n)
    },

    smoothSheet (n, o) {
      this.setParameters(this.representationSetting.object, this.representationSetting.type, 'smoothSheet', n)
    },

    aspectRatio (n, o) {
      this.setParameters(this.representationSetting.object, this.representationSetting.type, 'aspectRatio', n)
    }
  },

  methods: {
    getStyleWidth (style) {
      let width = style.width
      let found = width.match(/(\d+)px/)
      return parseInt(found[1])
    },

    toggleSelection (selections) {
      let v = this

      for (let selection of selections) {
        let obj = selection.object
        let residue = selection.residue

        if (!v.currentSelection) {
          if (v.sele) {
            v.sele.visible = true
            v.sele.selections = [new NGL.Selection(`${residue.resno}:${residue.chainname}`)]
            v.sele.components = [obj.components[0]]
          } else {
            v.store.objects.push(v.store.makeObject('sele', 'selection', [obj.components[0]], [new NGL.Selection(`${residue.resno}:${residue.chainname}`)]))
            v.sele.visible = false
          }
        } else {
          let ind = v.currentSelection.components.findIndex(comp => comp === obj.components[0])
          if (ind !== -1) {
            let sele = v.currentSelection.selections[ind]
            let str = sele.string
            if (residue.active) {
              sele.setString(`(${str}) and (not (${residue.resno}:${residue.chainname}))`)
            } else {
              sele.setString(`(${str}) or (${residue.resno}:${residue.chainname})`)
            }
          } else {
            v.currentSelection.components.push(obj.components[0])
            if (residue.active) {
              v.currentSelection.selections.push(new NGL.Selection(`not (${residue.resno}:${residue.chainname})`))
            } else {
              v.currentSelection.selections.push(new NGL.Selection(`${residue.resno}:${residue.chainname}`))
            }
          }
        }
      }

      v.currentSelection.updateSelection()

      v.$emit('update:selection')
    },

    setParameters (id, type, parameter, value) {
      let v = this
      if (id > 0) {
        let obj = v.store.getObjectById(id)
        if (obj.type === 'all' || obj.type === 'structure-component') {
          obj.components.forEach(comp => {
            if (hasRepr(comp, type)) {
              let repr = getRepr(comp, type)
              let opt = {}
              opt[parameter] = value
              repr.setParameters(opt)
            }
          })
        }
      }
    },

    getMenuStyle (ind) {
      if (ind === -1) {
        return {
          display: 'none'
        }
      } else {
        let e = document.getElementById(`object-row-${ind}`)
        let p = e.parentElement
        return {
          display: 'block',
          top: `${e.offsetTop - p.offsetTop}px`
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../styles/theme.scss";


$line-color: #eeeeee;

.left-border {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 19px;
  width: 5px;
  border-left: 2px solid grey;
  margin-left: -1px;
}

.left-border:hover {
  cursor: ew-resize;
}

.bottom-right-border {
  position: absolute;
  right: 3px;
  bottom: 0;
  width: 5px;
  height: 5px;
  border-right: 2px solid grey;
  border-bottom: 2px solid grey;
}

.bottom-right-border:hover {
  cursor: nwse-resize;
}

.control-panel-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid $line-color;
  cursor: pointer;
  margin-left: 3px;
  margin-right: 3px;
}

.control-panel-top {
  overflow-y: auto;
}

.control-panel-bottom >div {
  width: 20px;
}

.setting-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: $font-grey;
  padding: 10px;
}

.setting-label {
  width: 130px;
  min-width: 130px;
}

.setting-number {
  text-align: center;
  width: 50px;
  min-width: 50px;
}

.rename-box {
  position: relative;
}

.rename-input {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 100%;
}

.rename-input input {
  height: 100%;
  padding: 0px;
  border-radius: 1px;
  box-sizing: border-box;
}

.object-row {
  font-size: 11px;
  display: flex;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid $line-color;
  cursor: pointer;
  text-align: center;
}

.object-row >div:nth-child(n+2) {
  border-left: 1px solid $line-color;
  font-weight: 700;
  color: $font-grey;
}

.object-name {
  box-sizing: border-box;
  padding: 2px 5px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: $font-grey;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
}

.object-name.object-name-active {
  background-color: grey;
  color: white;
}

.object-action {
  width: 20px;
  max-width: 20px;
}

.object-show {
  width: 20px;
  max-width: 20px;
}

.object-hide {
  width: 20px;
  max-width: 20px;
}

.object-label {
  width: 20px;
  max-width: 20px;
}

.object-color {
  width: 20px;
  max-width: 20px;
}

.object-setting {
  width: 20px;
  max-width: 20px;
}

.object-setting i {
  transform: rotate(90deg)
}

</style>
